import type { AxiosProgressEvent } from 'axios';

export class ApiRequest {
  public method: "POST" | "GET" | "PUT" | "DELETE" | "PATCH";
  public url: string;
  public query?: Record<string, string>;
  public data?: any;
  public headers?: Record<string, string>;
  public authenticated: boolean;
  public signal?: AbortSignal;
  public responseType: 'json' | 'blob' | 'arraybuffer' | 'text';
  public onUploadProgress?: (progressEvent: AxiosProgressEvent) => void;

  constructor({
    method,
    url,
    query,
    data,
    headers,
    authenticated = true,
    responseType = 'json',
    onUploadProgress,
    signal,
  }: {
    method: "POST" | "GET" | "PUT" | "DELETE" | "PATCH";
    url: string;
    query?: Record<string, string>;
    data?: any;
    headers?: Record<string, string>;
    authenticated?: boolean;
    responseType?: 'json' | 'blob' | 'arraybuffer' | 'text';
    onUploadProgress?: (progressEvent: AxiosProgressEvent) => void;
    signal?: AbortSignal;
  }) {
    this.method = method;
    this.url = url;
    this.query = query;
    this.data = data;
    this.headers = headers;
    this.authenticated = authenticated;
    this.responseType = responseType;
    this.onUploadProgress = onUploadProgress;
    this.signal = signal;
  }
}
